// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"HP-z","categoryName":"IP-z","categoryNameSearchHeader":"JP-z","categoryContent":"KP-z","bottomAligned":"LP-z","image":"MP-z","imageNoBackground":"NP-z"};